import {MI} from "../init";

/**
 * @constructor
 * @returns {undefined}
 */
import {FsFires} from "./FsFires";

export function FsAnims()
{
	/** @type {FsFires} */
	this._fsFires;

	/** @type {MadnesObject} */
	this._fsLabel;

	/** @type {MadnesTween} */
	this._fsLabelTweenScale;

	/** @type {MadnesTween} */
	this._fsLabelTweenAlpha;

	/** @type {number} */
	this._fsLabelScale;

	/** @type {MadnesObject} */
	this._fsLabelBg;

	this._fsFiresComplete = function() {};
}

/**
 * @param {Function} func
 */
FsAnims.prototype.setFsFiresComplete = function(func) {
	this._fsFiresComplete = func;
};

/**
 * @param {MadnesGroup} group
 * @param {number=} xAdd
 * @param {number=} yAdd
 * @param {number=} offset
 * @param {number=} scale
 */
FsAnims.prototype.create = function(group, xAdd, yAdd, offset, scale) {
	this._fsFires = new FsFires();
	this._fsFires.create(group, xAdd, yAdd, offset, scale);
};

/**
 * @param {number=} x
 * @param {number=} y
 * @param {number=} scale
 */
FsAnims.prototype.createLabel = function(x, y, scale) {
	this._fsLabelScale = typeof scale !== "undefined" ? scale : 2;

	var xx = typeof x !== "undefined" ? x : MI.getWi() / 2;
	var yy = typeof y !== "undefined" ? y : 330;

	this._fsLabel = MI.addImg(xx, yy, null);
	this._fsLabel.setAnchor(0.5, 0.5);
	this._fsLabel.setScale(0, 0);

	this._fsLabelBg = MI.addImg(0, 0, "fire_fs_atlas");
	this._fsLabelBg.setAnchor(0.5, 0.5);
	this._fsLabelBg.setScale(2, 2);
	this._fsLabelBg.createAnims();
	this._fsLabelBg.anims.add("fire", MI.generateFrameNames("fire_free-spins_", 0, 17, "", 5));
	this._fsLabel.addChild(this._fsLabelBg);

	var fsText = MI.addImg(0, 0, "fs_text");
	fsText.setAnchor(0.5, 0.5);

	this._fsLabel.addChild(fsText);
};

FsAnims.prototype.play = function() {
	var _self = this;

	this._fsFires.run(function() {
		_self._fsFiresComplete && _self._fsFiresComplete();
	});

	return this._playFsLabelAnim(function() {
		_self._fsFires.hide();
	});
};

/**
 * @param {Function} callback
 * @returns {Promise}
 */
FsAnims.prototype._playFsLabelAnim = function(callback) {

	var _self = this;

	return new Promise(function(res) {

		_self._fsLabelBg.anims.loop("fire");

		var initScale = _self._fsLabelScale / 2;

		_self._fsLabel.setScale(0, 0);
		_self._fsLabel.setAlpha(1);

		_self._fsLabelTweenScale = MI.addTween().to(_self._fsLabel, { 'x': 0.8 * initScale, 'y': 0.8 * initScale }, {
			'scale': true,
			'duration': 400,
			'callback': function() {
				_self._fsLabelTweenScale = MI.addTween().to(_self._fsLabel, { 'x': _self._fsLabelScale * 0.5, 'y': _self._fsLabelScale * 0.5 }, {
					'scale': true,
					'duration': 350,
					//'delay': 100,
					'yoyo': true,
					'callback': function() {

						_self._fsLabelTweenScale = MI.addTween().to(_self._fsLabel, { 'x': _self._fsLabelScale * 0.5, 'y': _self._fsLabelScale * 0.5 }, {
							'scale': true,
							'duration': 350,
							'callback': function() {
								_self._fsLabelTweenScale = MI.addTween().to(_self._fsLabel, { 'x': _self._fsLabelScale, 'y': _self._fsLabelScale }, {
									'scale': true,
									'duration': 350
								});
								_self._fsLabelTweenAlpha = MI.addTween().to(_self._fsLabel, { 'alpha': 0 }, {
									'duration': 350,
									'callback': function() {
//										_self._fsLabel.destroy();
//										_self._fsLabel = null;
//										_self._fsLabelBg = null;
										res();
									}
								});
							}
						});
						callback();
					}
				});
			}
		});
	});
};

FsAnims.prototype.destroy = function() {

	this._fsFires.destroy();
	this._fsFires = null;

	this._fsLabelTweenScale && this._fsLabelTweenScale.destroy();
	this._fsLabelTweenAlpha && this._fsLabelTweenAlpha.destroy();

	if(this._fsLabel) {
		this._fsLabel.destroy();
		this._fsLabel = null;
		this._fsLabelBg = null;
	}

	this._fsFiresComplete = null;
};